import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { map } from 'rxjs';
import { Brand } from '../../models/new/brand.model';
import { GraphQLService } from '../../../../services/graph-ql.service';
import { DatabaseQueries } from '../../../../shared/types/get-query';
import { AppService } from '../../../../app.service';
import { MatDialog } from '@angular/material/dialog';
import { FilterListComponent } from '../../../../shared/components/filter-list/filter-list.component';
import { BrandFilterService } from 'src/app/services/filters/brand-filter.service';
import * as _ from 'lodash';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { StyleMapper } from '../../services/style-mapper';
import { Color, Gender, Style, StyleFilters, StyleStatus } from '../../models/new/style';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.component';
import { Category } from '../../models/new/category';
import { StyleGroup } from '../../models/new/style-group';
import { StyleDescription } from '../../models/new/style-description';
import { Collection } from '../../models/new/collection';
import { Purpose } from '../../models/new/purpose';
import { Team } from '../../models/new/team';
import { CategoryFilterService } from 'src/app/services/filters/category-filter.service';
import { StyleGroupFilterService } from 'src/app/services/filters/style-group-filter.service';
import { StyleDescriptionFilterService } from 'src/app/services/filters/style-description-filter.service';
import { CollectionFilterService } from 'src/app/services/filters/collection-filter.service';
import { PurposeFilterService } from 'src/app/services/filters/purpose-filter.service';
import { GenderFilterService } from 'src/app/services/filters/gender-filter.service';
import { TeamFilterService } from 'src/app/services/filters/team-filter.service';
import { StringFilterListComponent } from 'src/app/shared/components/string-filter-list/string-filter-list.component';
import { Status } from '../../models/new/status';
import { OrderStatusFilterService } from 'src/app/services/filters/style-status-filter.service';
import { ImageService } from 'src/app/services/image.service';
import { Order } from '../../models/new/order';
import { OrderMapper } from '../../services/order-mapper';
import { Paginable } from 'src/app/shared/types/paginable';
import { Selectable } from 'src/app/shared/types/selectable.type';
import { OrdersModalComponent } from './orders-modal/orders-modal.component';
import { AddToOrderModalComponent } from './add-to-order-modal/add-to-order-modal.component';
import { SelectedStylesModalComponent } from './selected-styles-modal/selected-styles-modal.component';
import { Warehouse } from 'src/app/shared/types/warehouse.model';
import { WarehouseFilterService } from 'src/app/services/filters/warehouse-filter.service';
import { WarehouseArticleResumeeModalComponent } from './warehouse-article-resumee-modal/warehouse-article-resumee-modal.component';
import { ExcelService, StyleResumeeListRequest } from 'src/app/services/excel.service';

@Component({
	standalone: false,
	selector: 'bt-company-style-list',
	templateUrl: './company-style-list.component.html',
	styleUrls: ['./company-style-list.component.scss']
})
export class CompanyStyleListComponent implements OnInit {
	loading: boolean = false;
	styles: Paginable<Style> = new Paginable<Style>();
	styleFilters: StyleFilters = new StyleFilters();
	styleStatus = StyleStatus;
	selectedStyles: Style[] = [];

	constructor(
		private graphQlService: GraphQLService,
		private dialog: MatDialog,
		private route: ActivatedRoute,
		private utilitiesService: UtilitiesService,
		private brandFilterService: BrandFilterService,
		private warehouseFilterService: WarehouseFilterService,
		private styleStatusFilterService: OrderStatusFilterService,
		private categoryFilterService: CategoryFilterService,
		private styleGroupFilterService: StyleGroupFilterService,
		private styleDescriptionFilterService: StyleDescriptionFilterService,
		private collectionFilterService: CollectionFilterService,
		private purposeFilterService: PurposeFilterService,
		private genderFilterService: GenderFilterService,
		private teamFilterService: TeamFilterService,
		private styleMapper: StyleMapper,
		private router: Router,
		private imageService: ImageService,
		private excelService: ExcelService
	) {}

	ngOnInit(): void {
		this.getStyles();
	}

	getLabel(filter: string): string {
		switch (filter) {
			case 'brands':
				return this.styleFilters.brands && this.styleFilters.brands.length ? this.styleFilters.brands.map((b) => b.name).join(', ') : '';
			case 'categories':
				return this.styleFilters.categories && this.styleFilters.categories.length ? this.styleFilters.categories.map((c) => c.name).join(', ') : '';
			case 'styleGroups':
				return this.styleFilters.styleGroups && this.styleFilters.styleGroups.length ? this.styleFilters.styleGroups.map((sg) => sg.name).join(', ') : '';
			case 'styleDescriptions':
				return this.styleFilters.styleDescriptions && this.styleFilters.styleDescriptions.length ? this.styleFilters.styleDescriptions.map((sd) => sd.name).join(', ') : '';
			case 'collections':
				return this.styleFilters.collections && this.styleFilters.collections.length ? this.styleFilters.collections.map((c) => c.name).join(', ') : '';
			case 'purposes':
				return this.styleFilters.purposes && this.styleFilters.purposes.length ? this.styleFilters.purposes.map((p) => p.name).join(', ') : '';
			case 'genders':
				return this.styleFilters.genders && this.styleFilters.genders.length ? this.styleFilters.genders.map((g) => g.name).join(', ') : '';
			case 'teams':
				return this.styleFilters.teams && this.styleFilters.teams.length ? this.styleFilters.teams.map((t) => t.name).join(', ') : '';
			default:
				return '';
		}
	}

	getWarehousesByStyle(style: Style): Array<Warehouse> {
		let warehouses: Warehouse[] = [];
		if (!style.warehouseArticles || !style.warehouseArticles.length) return [];

		for (const warehouseArticle of style.warehouseArticles ?? []) {
			if (!warehouseArticle.warehouse?.id) continue;
			if ((warehouseArticle.availableQty ?? 0) <= 0 || warehouseArticle.operationType === 'D') continue;

			//pusha solo se non è già presente
			if (!warehouses.find((w) => w.id == warehouseArticle.warehouse?.id)) {
				warehouses.push(warehouseArticle.warehouse);
			}
		}

		return warehouses;
	}

	prepareFilterOptions(params: Params) {
		//questi chiamate servono per popolare il nome delle tendine di parametri in input tramite url

		if (params['brands'] && params['brands'].length)
			this.brandFilterService.searchById(params['brands']).subscribe((res: Brand[]) => {
				this.styleFilters.brands?.forEach((brand) => {
					brand.name = res.find((b) => b.id == brand.id)?.name;
				});
			});

		if (params['categories'] && params['categories'].length) {
			console.log('params categories', params['categories']);
			this.categoryFilterService.searchById(params['categories']).subscribe((res: Category[]) => {
				this.styleFilters.categories?.forEach((category) => {
					console.log('category before', category);
					category.name = res.find((c) => c.id == category.id)?.name;
				});
			});
		}

		if (params['styleGroups'] && params['styleGroups'].length)
			this.styleGroupFilterService.searchById(params['styleGroups']).subscribe((res: StyleGroup[]) => {
				this.styleFilters.styleGroups?.forEach((styleGroup) => {
					styleGroup.name = res.find((sg) => sg.id == styleGroup.id)?.name;
				});
			});

		if (params['styleDescriptions'] && params['styleDescriptions'].length)
			this.styleDescriptionFilterService.searchById(params['styleDescriptions']).subscribe((res: StyleDescription[]) => {
				this.styleFilters.styleDescriptions?.forEach((styleDescription) => {
					styleDescription.name = res.find((sd) => sd.id == styleDescription.id)?.name;
				});
			});

		if (params['collections'] && params['collections'].length)
			this.collectionFilterService.searchById(params['collections']).subscribe((res: Collection[]) => {
				this.styleFilters.collections?.forEach((collection) => {
					collection.name = res.find((c) => c.id == collection.id)?.name;
				});
			});

		if (params['purposes'] && params['purposes'].length)
			this.purposeFilterService.searchById(params['purposes']).subscribe((res: Purpose[]) => {
				this.styleFilters.purposes?.forEach((purpose) => {
					purpose.name = res.find((p) => p.id == purpose.id)?.name;
				});
			});

		if (params['genders'] && params['genders'].length)
			this.genderFilterService.searchById(params['genders']).subscribe((res: Gender[]) => {
				this.styleFilters.genders?.forEach((gender) => {
					gender.name = res.find((g) => g.id == gender.id)?.name;
				});
			});

		if (params['teams'] && params['teams'].length)
			this.teamFilterService.searchById(params['teams']).subscribe((res: Team[]) => {
				this.styleFilters.teams?.forEach((team) => {
					team.name = res.find((t) => t.id == team.id)?.name;
				});
			});

		if (params['statuses'] && params['statuses'].length)
			this.styleStatusFilterService.searchById(params['statuses']).subscribe((res: Status[]) => {
				this.styleFilters.statuses?.forEach((status) => {
					status.name = res.find((s) => s.id == status.id)?.name;
				});
			});

		if (params['warehouses'] && params['warehouses'].length)
			this.warehouseFilterService.searchById(params['warehouses']).subscribe((res: Warehouse[]) => {
				this.styleFilters.warehouses?.forEach((warehouse) => {
					warehouse.description = res.find((w) => w.id == warehouse.id)?.description;
				});
			});
	}

	pageEvent(event: { pageNumber: number; pageSize: number }) {
		this.styles.currentPage = event.pageNumber;
		this.styles.size = event.pageSize;

		this.styleFilters.page = event.pageNumber;
		this.styleFilters.size = event.pageSize;

		this.refreshNavigation();
	}

	getStyles() {
		this.loading = true;

		this.route.queryParams.subscribe((params: Params) => {
			this.styleFilters = this.styleMapper.urlToFilters(params);

			this.prepareFilterOptions(params);

			this.styles.currentPage = this.styleFilters.page || 1;
			this.styles.size = this.styleFilters.size || 20;

			const pagination = this.styles.buildQuery(this.styles.currentPage);

			this.graphQlService
				.getData<any>(DatabaseQueries.GET_STYLES, {
					where: this.styleMapper.toWhereClause(this.styleFilters),
					...pagination
				})
				.pipe(
					map((res: any) => {
						const styles = res.data.styles;

						const paginable = new Paginable<Style>({
							items: styles.nodes.map((node: any) => this.styleMapper.toStyle(node)),
							totalCount: styles.totalCount,
							currentPage: this.styles.currentPage,
							size: this.styles.size
						});

						return paginable;
					})
				)
				.subscribe({
					next: (data: Paginable<Style>) => {
						this.styles = data;
						this.loading = false;
					},
					error: (err) => {
						this.utilitiesService.showSnackbar('Error fetching styles', SnackbarType.Error);
						this.loading = false;
						console.error(err);
					}
				});
		});
	}

	isSelected(modelId: number): boolean {
		return this.selectedStyles.some((s) => s.modelId == modelId);
	}

	refreshNavigation() {
		this.loading = true;

		this.router.navigate([location.pathname], {
			queryParams: this.styleMapper.filtersToUrl(this.styleFilters)
		});
	}

	selectStyle(style: Style) {
		if (this.isSelected(style.modelId!)) {
			this.selectedStyles = this.selectedStyles.filter((s) => s.modelId !== style.modelId);
		} else {
			this.selectedStyles.push(style);
		}
	}

	deselectAll() {
		this.selectedStyles = [];
	}

	cleanFilter(filter: string) {
		switch (filter) {
			case 'brands':
				this.styleFilters.brands = [];
				break;
			case 'categories':
				this.styleFilters.categories = [];
				break;

			case 'styleGroups':
				this.styleFilters.styleGroups = [];
				break;
			case 'styleDescriptions':
				this.styleFilters.styleDescriptions = [];
				break;
			case 'collections':
				this.styleFilters.collections = [];
				break;
			case 'purposes':
				this.styleFilters.purposes = [];
				break;
			case 'genders':
				this.styleFilters.genders = [];
				break;
			case 'teams':
				this.styleFilters.teams = [];
				break;
			case 'styleCode':
				this.styleFilters.styleCode = '';
				break;
			case 'statuses':
				this.styleFilters.statuses = [];
				break;
			case 'warehouses':
				this.styleFilters.warehouses = [];

			default:
				break;
		}

		//se si pulisce un filtro, porta a pagina 1
		this.styleFilters.page = 1;

		this.refreshNavigation();
	}

	openStyleCodesFilter() {
		this.dialog
			.open(StringFilterListComponent, {
				data: { title: 'Style Code', selected: this.styleFilters.styleCode }
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						this.styleFilters.styleCode = _.cloneDeep(res);

						this.refreshNavigation();
					}
				}
			});
	}

	openStatusFilterModal(): void {
		const dialog = this.dialog
			.open(FilterListComponent<Status>, {
				data: {
					title: 'Statuses',

					selected: this.styleFilters.statuses
						? this.styleFilters.statuses.map((el) => ({
								...el,
								displayId: el.id,
								displayName: el.name,
								selected: true
							}))
						: [],
					filterService: this.styleStatusFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Status>>) => {
					if (res) {
						this.styleFilters.statuses = res.map((el: any) => new Status({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openWarehouseFilterModal(): void {
		this.dialog
			.open(FilterListComponent<Warehouse>, {
				data: {
					title: 'Warehouses',
					singleSelection: true,
					selected: this.styleFilters.warehouses
						? this.styleFilters.warehouses.map((el) => ({
								...el,
								displayId: el.id,
								displayName: el.description,
								selected: true
							}))
						: [],
					filterService: this.warehouseFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Warehouse>>) => {
					if (res) {
						this.styleFilters.warehouses = res.map((el: any) => new Warehouse({ id: el.displayId, description: el.displayName }));

						this.refreshNavigation();
					}
				}
			});
	}

	openBrandFilterModal(): void {
		this.dialog
			.open(FilterListComponent<Brand>, {
				data: {
					title: 'Brands',
					selected: this.styleFilters.brands
						? this.styleFilters.brands.map((el) => ({
								...el,
								displayId: el.id,
								displayName: el.name,
								selected: true
							}))
						: [],
					filterService: this.brandFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Brand>>) => {
					if (res) {
						this.styleFilters.brands = res.map((el: any) => new Brand({ id: el.displayId, name: el.displayName }));

						this.refreshNavigation();
					}
				}
			});
	}

	openCategoryFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Categories',
					selected:
						this.styleFilters.categories?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.categoryFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Category>>) => {
					if (res) {
						this.styleFilters.categories = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openStyleGroupFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Style Groups',
					selected:
						this.styleFilters.styleGroups?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.styleGroupFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<StyleGroup>>) => {
					if (res) {
						this.styleFilters.styleGroups = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openStyleDescriptionFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Style Descriptions',
					selected:
						this.styleFilters.styleDescriptions?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.styleDescriptionFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<StyleDescription>>) => {
					if (res) {
						this.styleFilters.styleDescriptions = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openCollectionFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Collections',
					selected:
						this.styleFilters.collections?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.collectionFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Collection>>) => {
					if (res) {
						this.styleFilters.collections = res.map((el: any) => ({ id: el.displayId, name: el.displayName, startDate: el.startDate, endDate: el.endDate }));
						this.refreshNavigation();
					}
				}
			});
	}

	openPurposeFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Purposes',
					selected:
						this.styleFilters.purposes?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.purposeFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Purpose>>) => {
					if (res) {
						this.styleFilters.purposes = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openGenderFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Genders',
					selected:
						this.styleFilters.genders?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.genderFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Gender>>) => {
					if (res) {
						this.styleFilters.genders = res.map((el: any) => ({ id: el.displayId, name: el.displayName }));
						this.refreshNavigation();
					}
				}
			});
	}

	openTeamFilterModal(): void {
		this.dialog
			.open(FilterListComponent, {
				data: {
					title: 'Teams',
					selected:
						this.styleFilters.teams?.map((el) => ({
							...el,
							displayId: el.id,
							displayName: el.name,
							selected: true
						})) || [],
					filterService: this.teamFilterService
				},
				width: '400px'
			})
			.afterClosed()
			.subscribe({
				next: (res: Array<Selectable<Team>>) => {
					if (res) {
						this.styleFilters.teams = res.map((el: any) => ({ id: el.displayId, name: el.displayName, code: el.code }));
						this.refreshNavigation();
					}
				}
			});
	}

	canDownloadStyleResumeeList(): boolean {
		const hasCollection = !!this.styleFilters.collections?.length && !!this.styleFilters.collections[0]?.id;
		const hasStyleCode = !!this.styleFilters.styleCode?.trim();

		return hasCollection || hasStyleCode;
	}

	private buildStyleResumeeListPayload(): StyleResumeeListRequest | null {
		if (!this.canDownloadStyleResumeeList()) {
			return null;
		}

		const collectionId = this.styleFilters.collections?.[0]?.id;

		return {
			collectionId: collectionId ?? undefined,
			styleCode: this.styleFilters.styleCode?.trim() || '',
			//styleName: this.styleFilters.styleName?.trim() || undefined,
			brandId: this.styleFilters.brands?.[0]?.id,
			categoryId: this.styleFilters.categories?.[0]?.id,
			styleGroupId: this.styleFilters.styleGroups?.[0]?.id,
			styleDescriptionId: this.styleFilters.styleDescriptions?.[0]?.id,
			statusId: this.styleFilters.statuses?.[0]?.id,
			purposeId: this.styleFilters.purposes?.[0]?.id,
			genderId: this.styleFilters.genders?.[0]?.id,
			teamId: this.styleFilters.teams?.[0]?.id
		};
	}

	downloadStyleResumeeList(): void {
		const payload = this.buildStyleResumeeListPayload();
		if (!payload) return;

		this.loading = true;

		this.excelService.getStyleResumeeList(payload).subscribe({
			next: (res: Blob) => {
				this.loading = false;
				const url = window.URL.createObjectURL(res);
				const a = document.createElement('a');
				a.href = url;
				a.download = `Style_Resumee_List_${payload.collectionId}.xlsx`;
				a.click();
				window.URL.revokeObjectURL(url);
				this.utilitiesService.showSnackbar('Excel exported successfully', SnackbarType.Success);
			},
			error: () => {
				this.loading = false;
			}
		});
	}

	downloadImages(styles: Style[]): void {
		this.loading = true;

		if (styles.length > 0) {
			const modelIds = styles.map((style) => style.modelId!);

			this.imageService.DownloadImagesByModelIds(modelIds).subscribe({
				next: (res: Blob) => {
					this.loading = false;
					const url = window.URL.createObjectURL(res);
					window.open(url, '_blank');
				},
				error: (err) => {
					this.loading = false;
					//this.utilitiesService.showSnackbar('Failed to start download', SnackbarType.Error);
				}
			});
		}
	}

	openOrdersModal(orders: Order[]): void {
		this.dialog
			.open(OrdersModalComponent, {
				data: {
					orders: orders
				}
			})
			.afterClosed()
			.subscribe({
				next: (res) => {
					if (res) {
						//handle eventual actions on orders
					}
				}
			});
	}

	openWarehousesModal(style: Style): void {
		this.dialog.open(WarehouseArticleResumeeModalComponent, {
			data: {
				modelId: style.modelId,
				title: `${style.code} - ${style.name}`
			},
			width: '900px'
		});
	}

	openSelectedStylesModal() {
		this.dialog
			.open(SelectedStylesModalComponent, {
				data: {
					styles: this.selectedStyles
				}
			})
			.afterClosed()
			.subscribe({
				next: (res: any) => {}
			});
	}

	openAddToOrderModal(styles: Style[]): void {
		this.dialog
			.open(AddToOrderModalComponent, {
				data: {
					styles: styles,
					warehouse: this.styleFilters.warehouses && this.styleFilters.warehouses.length > 0 ? this.styleFilters.warehouses[0] : null
				}
			})
			.afterClosed()
			.subscribe({
				next: (res: Order | null) => {}
			});
	}
}
